
document.addEventListener('DOMContentLoaded', function () {
  var slider = document.getElementById('Slider-{{ section.id }}');
  // אם אין סליידר (למשל מצב גריד), לא עושים כלום
  if (!slider || !slider.classList.contains('slider')) return;

  var perPage = parseInt(slider.dataset.perPage || '{{ per_page }}', 10) || 4;
  var slides  = slider.querySelectorAll('.slider__slide');
  var pages   = Math.max(1, Math.ceil(slides.length / perPage));

  var dotsWrap = document.getElementById('Dots-{{ section.id }}');
  var dots     = dotsWrap ? dotsWrap.querySelectorAll('.slider-dot') : [];

  // החצים של הסקשן הזה בלבד
  var wrapper  = slider.closest('slider-component') || document;
  var prevBtn  = wrapper.querySelector('.slider-button--prev');
  var nextBtn  = wrapper.querySelector('.slider-button--next');

  var current = 0;

  function setActive(page) {
    current = Math.max(0, Math.min(pages - 1, page));
    dots.forEach(function (b, i) { b.classList.toggle('is-active', i === current); });
    if (prevBtn) prevBtn.disabled = (current === 0);
    if (nextBtn) nextBtn.disabled = (current === pages - 1);
  }

  function goToPage(page, smooth) {
    setActive(page);
    var index = current * perPage;                 // הפריט הראשון בעמוד
    var target = slides[index];
    if (!target) return;
    slider.scrollTo({ left: target.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
  }

  // חישוב העמוד הקרוב לפי מצב הגלילה (מדויק גם עם GAP)
  function nearestPageFromScroll() {
    var nearest = 0, min = Infinity;
    for (var p = 0; p < pages; p++) {
      var i = p * perPage;
      var off = slides[i] ? slides[i].offsetLeft : 0;
      var d = Math.abs(slider.scrollLeft - off);
      if (d < min) { min = d; nearest = p; }
    }
    return nearest;
  }

  // נקודות
  dots.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var p = parseInt(btn.dataset.page, 10) || 0;
      goToPage(p);
    });
  });

  // חצים
  if (prevBtn) prevBtn.addEventListener('click', function () { goToPage(current - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { goToPage(current + 1); });

  // עדכון נקודה פעילה בגלילה ידנית
  var ticking = false;
  slider.addEventListener('scroll', function () {
    if (ticking) return;
    requestAnimationFrame(function () {
      setActive(nearestPageFromScroll());
      ticking = false;
    });
    ticking = true;
  });

  // לשמור יישור אחרי ריסייז
  window.addEventListener('resize', function () { goToPage(current, false); });

  // התחלה
  setActive(0);
  goToPage(0, false);
});

